RivalIQ.module('utils', function (utils, App, Backbone, Marionette, $, _) {

    'use strict';

    const polling = utils.polling = {};

    polling.pollUntilCondition = function (api, condition, options) {

        options = options || {};
        options = _.defaults(options, {
            pollingMaxAttempts: 60,
            pollingDelay: 5000,
            retry: false
        });

        const deferred = new $.Deferred();

        // NOTE check if the condition is already true before starting polling; on this path, condition is called with no data
        if (!options.skipFailFast && condition()) {

            deferred.resolve();
            return deferred;
        }

        (function poll(attempt) {
            function delayedPoll(attempt) {
                window.setTimeout(function () {
                    window.requestAnimationFrame(function () {
                        poll(++attempt);
                    });
                }, options.pollingDelay);
            }

            if (options.pollingMaxAttempts !== -1 && attempt >= options.pollingMaxAttempts) {

                return deferred.reject({
                    type: 'max-attempts'
                });
            }

            api()
                .done(function (data) {

                    if (!condition(data)) {

                        return delayedPoll();
                    }

                    deferred.resolve();
                })
                .fail(function (error) {

                    if (options.retry) {
                        return delayedPoll();
                    }

                    deferred.reject(error);
                });

        }(0));

        return deferred;
    };


});
